// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"textformat-underline"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M17 4L17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12L7 4","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M19 21H5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TextformatUnderlineIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'textformat-underline',
    ref,
    icon: element,
  },
));

TextformatUnderlineIcon.displayName = 'TextformatUnderlineIcon';

export default TextformatUnderlineIcon;
